import { demoOrganizationCmId } from './demoOrganizationCmId';

export const isDemoOrganization = (): boolean =>
  window.location.pathname.includes(`/${demoOrganizationCmId}`);
